import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { Company } from './company.model';
import { CompanyInfoModalComponent } from '../components/company-info-modal/company-info-modal.component';

@Injectable({
  providedIn: 'root',
})
export class CompanyModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  /*openCompaniesInfoModal(companies: Company[]) {
    const options = {
      width: '650px',
      // height: '100vh',
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'COMPANIES',
        obj: companies,
      },
      // confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, CompaniesInfoModalComponent);
  }*/

  // Not used
  /* openCompanyInfoModal(company: Company) {
    const options = {
      // width: '650px',
      // height: '100vh',
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'COMPANY_DETAILS',
        obj: company,
      },
    };

    this.modalDialogService.open(options, CompanyInfoModalComponent);
  } */
}
